<div *ngIf="redirectError; else showRedirect">
	{{redirectError}}
</div>

<ng-template #showRedirect>
	Please wait, you will be redirected to Stripe.com shortly for card processing...
	
</ng-template>